import BasePageView from "components/core/BasePageView/BasePageView";
import useSellerContext from "hooks/useSellerContext";
import useGrnDetailsLogic from "./useGrnDetailsLogic";
import GrnDetailsDesktop from "./GrnDetailsDesktop";
import GrnDetailsMobile from "./GrnDetailsMobile";

const GrnDetailsView = () => {
  const vm = useGrnDetailsLogic();
  const { currentSellerDetail, allSellersDetails, handleProfileNavigate } = useSellerContext();

  return (
    <BasePageView
      DesktopView={GrnDetailsDesktop}
      MobileView={GrnDetailsMobile}
      viewProps={vm}
      headerProps={{
        showSubHeader: true,
        sellerDetail: currentSellerDetail,
        allSellerDetails: allSellersDetails,
        handleProfile: handleProfileNavigate,
      }}
    />
  );
};

export default GrnDetailsView;
